import React from 'react'
import { Stack } from '@mui/material'
import RoleItem from '../RoleItem'
import CategoryHeader from '../CategoryHeader'
import { useEditPermissions, useBatchModeState, useBatchModeHandlers } from '../../../use-category-roles'
import { getVisibleRoleKeys } from '../../../../helpers'
import type { BatchEditCategorySectionProps } from '../../../../types'

const BatchEditCategorySection: React.FC<BatchEditCategorySectionProps> = ({
  category,
  isInternal = false,
  rolesState,
  onRoleChange,
  colorScheme = 'green'
}) => {
  const { user } = useEditPermissions()
  if (!category || !user) return null

  const categoryRoles = getVisibleRoleKeys(category, isInternal)

  if (categoryRoles.length === 0) return null

  const { allAdded } = useBatchModeState(categoryRoles, rolesState)
  const { handleAddAll, handleReset } = useBatchModeHandlers(categoryRoles, onRoleChange)

  return (
    <Stack spacing={1} sx={{ p: '4px 8px' }}>
      <CategoryHeader
        categoryName={category.name}
        compact={true}
        allSelected={allAdded}
        onAddAll={handleAddAll}
        onReset={handleReset}
      />
      <Stack spacing={0.25}>
        {categoryRoles.map(role => (
          <RoleItem
            key={role}
            mode="management"
            role={role}
            state={rolesState[role] || 'unchanged'}
            onChange={onRoleChange}
            colorScheme={colorScheme}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default BatchEditCategorySection